import { MentionInputPlugin, MentionPlugin } from '@platejs/mention/react';
import { styled } from '@porsche-code/kado-styled-system/jsx';
import { useEditorRef, type PlateElementProps } from 'platejs/react';

import {
  PLACEHOLDER_ELEMENT,
  PLACEHOLDER_ELEMENT_INPUT,
} from '../placeholderToken';

const Container = styled('span', {
  base: {
    borderRadius: 'xl',
    px: 'sm',
    py: '2xs',
    backgroundColor: 'background.frostedStrong',
    color: 'text.primary',
  },
});

const Mention = ({
  attributes,
  element,
  children,
}: PlateElementProps & {
  prefix?: string;
  element: { value: { type: string } };
}) => {
  const editor = useEditorRef();

  const { MentionLabel, mentionProps } = editor.getOptions(MentionPlugin) as {
    MentionLabel?: React.FunctionComponent<{ value: { type: string } }>;
    mentionProps?: any;
  };

  return (
    <Container {...attributes} contentEditable={false}>
      {MentionLabel ? (
        <MentionLabel {...mentionProps} value={element.value} />
      ) : (
        JSON.stringify(element.value)
      )}
      {children}
    </Container>
  );
};

const MentionInput = ({ attributes, children }: PlateElementProps) => (
  <span {...attributes}>{children}</span>
);

export const mentionComponents = {
  [MentionPlugin.key]: Mention,
  [MentionInputPlugin.key]: MentionInput,
  [PLACEHOLDER_ELEMENT]: Mention,
  [PLACEHOLDER_ELEMENT_INPUT]: MentionInput,
};
